import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, TextField } from '@mui/material';
import { Icons } from '~/views/atoms/icons';
import React from 'react';
import { theme } from '~/theme/default';
export function FormikFieldAutocomplete({ name, label, formikProps, options, ...props }) {
    const { handleChange, values } = formikProps;
    return (_jsx(Autocomplete, { id: name, value: values[name] || null, onChange: handleChange, isOptionEqualToValue: (option, value) => option.id === value.id, ...props, options: options || [], popupIcon: _jsx(Icons.ArrowDown, { sx: { color: theme.palette.info.main } }), renderInput: params => (_jsx(TextField, { sx: { color: values[name] ? undefined : '#9b9b9c' }, placeholder: label || props.placeholder, label: props.placeholder || label, name: name, ...params })), renderOption: (props, option) => {
            return (_createElement("li", { ...props, key: option.id }, option.label));
        } }));
}
